import React from 'react';
import { LegalEntityEdit as LegalEntityEditContainer } from '../../containers';
import { Layout } from 'antd';

class LegalEntityEdit extends React.Component {
  render() {
    const query = Object.fromEntries(
      new URLSearchParams(this.props.location.search)
    );

    if (query.productionUnitId) {
      query.productionUnitId = +query.productionUnitId;
    }

    return (
      <Layout className="main-container">
        <Layout.Content>
          <LegalEntityEditContainer
            registerCode={this.props.match.params.registerCode}
            isEditMode
            queryParams={query}
          />
        </Layout.Content>
      </Layout>
    );
  }
}

export default LegalEntityEdit;
